import { HTTPBaseRepository } from "../../domain/HTTPBaseRepository";
import { AxiosHTTPCoreBaseRepository } from "../axios/AxiosHTTPBaseRepository";

export class CoreHTTPBaseRepository
  extends AxiosHTTPCoreBaseRepository
  implements HTTPBaseRepository
{
  constructor() {
    // TODO: lower the timeout, and see if we can remove such a large timeout already
    // Yes, the timeout is ridiculously high, but it's just because our API is slow
    super(process.env.CORE_BASE_URL ?? "https://core.permisso.io", 10000);
  }

  async request<T>(config: {
    method: "POST" | "GET" | "PUT" | "DELETE" | "PATCH";
    url: string;
    data?: any;
    headers?: {
      [key: string]: string;
    };
    params?: { [key: string]: string };
  }) {
    const { data } = await this.axiosInstance.request(config);
    return data as T;
  }
}
